import i18n from "i18next";

export interface BreadcrumbsItem {
  label: string;
  path: string;
  dustinIcon?: string;
  isDisabled?: boolean;
}

export interface BreadcrumbsConfigItem {
  label: string;
  crumbs?: BreadcrumbsItem[];
  dustinIcon?: string;
  match: { path: string; exact?: boolean };
}

export const getBreadcrumbsConfig = (): BreadcrumbsConfigItem[] => {
  const StartPage: BreadcrumbsItem = {
    label: i18n.t("breadcrumbs:start"),
    path: "/start",
  };

  const Other: BreadcrumbsItem = {
    label: i18n.t("breadcrumbs:other"),
    path: "/",
    isDisabled: true,
  };

  const Documents: BreadcrumbsItem = {
    label: i18n.t("breadcrumbs:documents"),
    path: "/documents",
  };

  const breadcrumbsConfig: BreadcrumbsConfigItem[] = [
    {
      label: Documents.label,
      crumbs: [StartPage, Other],
      match: {
        path: Documents.path,
        exact: true,
      },
    },
    {
      label: i18n.t("breadcrumbs:preview"),
      crumbs: [StartPage, Other, Documents],
      match: {
        path: "/documents/preview",
      },
    },
  ];

  return breadcrumbsConfig;
};
